<template>
    <div class="el-grid-card">
        <div class="el-grid-card__body">
            <el-row>
                <div class="el-grid-card__header">
                    {{ $t('title.overview') }}
                    <v-btn
                        style="
                            right: 0;
                            position: relative;
                            float: right;
                            margin-top: 10px;
                        "
                        round
                        color="primary"
                        dark
                        @click="showCreateUserGroupView"
                        v-if="permissions.includes('USER_WRITE')"
                    >
                        {{ $t('button.text.createGroup') }}
                    </v-btn>
                </div>
                <el-row>
                    <el-col :span="6" :offset="1">
                        <v-text-field
                            :label="$t('form.label.search')"
                            v-model="searchTerm"
                            append-icon="search"
                            class="el-light-search"
                        ></v-text-field>
                    </el-col>
                </el-row>
                <el-table
                    :data="searchResults"
                    size="mini"
                    highlight-current-row
                    :empty-text="$t('message.warning.nodataSelectContainer')"
                    class="w-full mb-6"
                    style="width: 100%"
                    v-loading="loading"
                    border
                >
                    <el-table-column
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, 'GroupName')"
                        prop="GroupName"
                        :label="$t('form.label.groupName')"
                    ></el-table-column>
                    <el-table-column
                        sortable
                        prop="Users"
                        :label="$t('form.label.members')"
                    >
                        <template slot-scope="scope">
                            <p
                                v-for="user in scope.row.Users"
                                :key="user.UserID"
                            >
                                {{ user.FirstName }} {{ user.LastName }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="Users.Username"
                        :label="$t('form.label.email')"
                    >
                        <template slot-scope="scope">
                            <p
                                v-for="user in scope.row.Users"
                                :key="user.UserID"
                            >
                                {{ user.Username || 'n/a' }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="Company"
                        :label="$t('form.label.company')"
                    >
                        <template slot-scope="scope">
                            <p
                                v-for="user in scope.row.Users"
                                :key="user.UserID"
                            >
                                {{ user.Company || 'n/a' }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.operations')"
                        width="120"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <div class="btn-action-wrapper">
                                <a
                                    href="#"
                                    class="btn-action"
                                    title="Edit"
                                    @click.prevent="edit(row)"
                                    v-if="permissions.includes('USER_WRITE')"
                                >
                                    <v-btn flat icon color="cyan darken-3">
                                        <v-icon>mode_edit</v-icon>
                                    </v-btn>
                                </a>
                                <a
                                    href="#"
                                    class="btn-action"
                                    @click.prevent="remove(row)"
                                    title="Delete"
                                    v-if="permissions.includes('USER_DELETE')"
                                >
                                    <v-btn flat icon color="red darken-3">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    :page-count="totalPages"
                    :total="totalCount"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40, 50, 100, 500]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    style="margin-top: 10px"
                >
                </el-pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import InteractWithSort from '../../mixins/interact-with-sort'
import Treeselect from '@riophae/vue-treeselect'

export default {
    name: 'user-groups-list',

    data() {
        return {
            userGroups: [],
            loading: false,
            showContainerAndPermissions: false,
            selectedContainers: [],
            treeValueConsistsOf: 'ALL',
            includeSubContainers: false,
            isFlat: true,
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            treeLimit: 2,
            // containerPermissionDataReq: [],
            // containerList: [],
            unloadingAreas: [],
            // permissionsList: [],
            totalPages: 1,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            searchResults: [],
            searchTerm: '',
        }
    },

    mixins: [InteractWithSort],
    components: {
        treeselect: Treeselect,
    },
    computed: {
        ...mapGetters([
            'selectedContainer',
            'permissions',
            'containerTree',
            'containers',
        ]),
        selectedContainerTree() {
            return [this.selectedContainer]
        },
        searchOptions() {
            return {
                keys: [
                    'GroupName',
                    'Description',
                    'Users.Username',
                    'Users.FirstName',
                    'Users.LastName',
                    'Users.Company',
                ],
            }
        },
    },

    async created() {
        this.selectedContainers = [this.selectedContainer] // Current selected parent container will be selected by default.

        // Update user group list
        Events.$on('update-user-group-list', () => {
            this.onApply(1, this.selectedContainers)
        })
    },

    beforeDestroy() {
        // Events.$off('user-updated')
        Events.$off('update-user-group-list')
    },

    watch: {
        searchTerm: _.debounce(async function () {
            if (this.searchTerm !== '') {
                this.searchResults = await this.$search(
                    this.searchTerm,
                    this.userGroups,
                    this.searchOptions
                )
            } else {
                this.searchResults = this.userGroups
            }
        }, 500),
        selectedContainers: _.debounce(function () {
            this.$nextTick(() => {
                this.onApply(1)
            })
        }, 500),
    },

    methods: {
        getContainerDescriptions(permissionsArr) {
            let permissionIdList = _.uniq(_.map(permissionsArr, 'ContainerID'))
            let containersList = []
            permissionIdList.forEach((permissionId) => {
                this.containers.forEach((container) => {
                    if (container.ContainerID === permissionId) {
                        containersList.push(container)
                    }
                })
            })
            return _.map(containersList, 'Description').join(', ')
        },
        showCreateUserGroupView() {
            Events.$emit('show-create-or-edit-group-view', true)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.onApply(val)
        },

        handleSizeChange(val) {
            this.pageSize = val
            // this.fetch(this.selectedContainer)
            this.onApply(this.currentPage)
        },
        async groupByCategoryName(array, key, fn) {
            let hash = Object.create(null)
            return array.reduce(function (r, o) {
                if (!hash[o[key]]) {
                    hash[o[key]] = {}
                    hash[o[key]][key] = o[key]
                    r.push(hash[o[key]])
                }
                fn(o, hash[o[key]])
                return r
            }, [])
        },
        changeIncludeSubContainers() {
            // let currentSelectedContainers = this.selectedContainers;
            if (this.includeSubContainers) {
                this.selectedContainers = null
                setTimeout(
                    function () {
                        this.isFlat = false
                        this.isFlat = false
                    }.bind(this),
                    1000
                )
            } else {
                this.selectedContainers = null
                setTimeout(
                    function () {
                        this.isFlat = true
                    }.bind(this),
                    1000
                )
            }
        },

        async handleBeforeClearAll() {
            try {
                await this.$confirm(
                    'Are you sure you want clear the fields?',
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )
                return true
            } catch (e) {
                return false
            }
        },
        async onApplyBtnClick(currentPage) {
            this.searchTerm = ''
            if (!currentPage) {
                currentPage = 1
            }
            this.loading = true
            this.currentPage = currentPage

            if (this.selectedContainers.length === 0) {
                this.loading = false
                try {
                    this.$alert(
                        this.$i18n.i18next.t('message.warning.selectContainer'),
                        {
                            confirmButtonText: 'OK',
                        }
                    )
                } catch (e) {
                    return false
                }
                return false
            }

            let requestObj = {
                ContainerFilter: [
                    ...this.selectedContainers.map(
                        (container) => container.ContainerID
                    ),
                ],
                CurrentPage: this.currentPage,
                PageSize: this.pageSize,
            }

            let { data } = await this.$http.post(
                `/UserGroup/${this.selectedContainer.ContainerID}`,
                requestObj
            )
            this.totalPages = data.TotalPages
            this.currentPage = data.CurrentPage
            this.totalCount = data.TotalCount
            this.userGroups = data.result
            this.searchResults = this.userGroups
            this.loading = false
        },

        async onApply(
            currentPage,
            containersSelected = this.selectedContainers
        ) {
            if (!currentPage) {
                currentPage = 1
            }
            this.loading = true
            this.currentPage = currentPage

            if (!containersSelected || containersSelected.length === 0) {
                this.totalPages = 1
                this.currentPage = 1
                this.totalCount = 0
                this.userGroups = []
                this.searchResults = []
                this.loading = false
                return false
            }

            let requestObj = {
                ContainerFilter: [
                    ...containersSelected.map(
                        (container) => container.ContainerID
                    ),
                ],
                CurrentPage: this.currentPage,
                PageSize: this.pageSize,
            }

            let { data } = await this.$http.post(
                `/UserGroup/${this.selectedContainer.ContainerID}`,
                requestObj
            )
            this.totalPages = data.TotalPages
            this.currentPage = data.CurrentPage
            this.totalCount = data.TotalCount
            this.userGroups = data.result
            this.searchResults = this.userGroups
            this.loading = false
        },

        edit(group) {
            this.showCreateUserGroupView()
            this.$nextTick(() => {
                Events.$emit('group-editing', group)
            })
        },

        async remove(group) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: this.$i18n.i18next.t('text.userGroup'),
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                await this.$http.delete(`UserGroup/${group.UserGroupID}`)
                await this.onApply(this.currentPage)

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: this.$i18n.i18next.t('text.userGroup'),
                    }),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },
    },
}
</script>
<style>
.current-row {
    background-color: #35c8b5b8 !important;
}
</style>
